export default [
  {
    path: '/satis-hedef-group',
    name: 'satis-hedef-group-list',
    component: () => import('./index.vue'),
    meta: {
      public: false,
      title: 'satis_hedef_group.Baslik',
      yetki: { k: [2002002] },
    },
  },
]
